import { render, staticRenderFns } from "./TenderAnnouncement.vue?vue&type=template&id=e834ab18&scoped=true"
import script from "./TenderAnnouncement.vue?vue&type=script&lang=js"
export * from "./TenderAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./TenderAnnouncement.vue?vue&type=style&index=0&id=e834ab18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e834ab18",
  null
  
)

export default component.exports